// login url
const login_url = process.env.VUE_APP_LOGIN_URL;

export default {
  name: 'LoginView',
  data() {
    return ({
      credentials: {
        email: '',
        password: ''
      },
      password_input_type: 'password',
      is_loading: false,
      error_message: '',
      success_message: '',
      login_url: login_url
    });
  },
  methods: {
    toggle_change_password_type() {
      this.password_input_type = this.password_input_type === 'password' ? 'text' : 'password';
    },

    async handle_login() {
      try {
        this.is_loading = true;
        this.error_message = '';

        // Validate inputs
        if (!this.credentials.email || !this.credentials.password) {
          this.error_message = 'Please enter both email and password';
          this.is_loading = false;
          return;
        }

        // Make login request
        const response = await fetch(this.login_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            username: this.credentials.email,
            password: this.credentials.password,
            client_app: 'npi'
          })
        });
        
        if (!response.ok) {
          throw new Error(`Login failed: ${response.status}`);
        }

        // Parse response
        const raw_response = await response.text();
        let data;

        try {
          data = JSON.parse(raw_response);
          // Handle double-encoded JSON
          if (typeof data === 'string') {
            data = JSON.parse(data);
          }
        } catch (e) {
          throw new Error('Invalid response format from server');
        }

        // Check if authentication was successful
        if (data.status !== 'success') {
          throw new Error(data.message || 'Authentication failed');
        }

        if (!data.challenge_token) {
          throw new Error('No OTP challenge received from server');
        }

        sessionStorage.setItem('pending_user_data', JSON.stringify(data.user || {}));
        sessionStorage.setItem('pending_username', this.credentials.email);
        sessionStorage.setItem('pending_challenge_token', data.challenge_token);
        sessionStorage.setItem('pending_login_password', this.credentials.password);
        this.success_message = 'Verification code has been sent to your email.';
        
        // Redirect to OTP Verification Screen
        this.$router.push('/one_time_pin');
        
        // Clear loading state after push
        this.is_loading = false;
        return;

      } catch (error) {
        this.error_message = error.message || 'Login failed. Please try again.';
        this.is_loading = false;
      }
    }
  }
}
